export const SET_USER_PLANS = 'SET_USER_PLANS';

export const setUserPlans = (payload) => dispatch => {
    dispatch({
        type: SET_USER_PLANS,
        payload
    });
};



// WEBPACK FOOTER //
// ./src/actions/plans.js